export default onlyWithPlacesLeft =>
  ({ attendance_capacity: attendanceCapacity, attendees }) =>
    !onlyWithPlacesLeft || attendees < attendanceCapacity;
